var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUpload2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M11,24a4.665,4.665,0,0,1-4.888-4.391V19.2H2A2,2,0,0,1,.153,17.987a1.933,1.933,0,0,1,.433-2.138l2.2-2.164V8.071A8.011,8.011,0,0,1,5.6,2a8.293,8.293,0,0,1,5.414-2A8.4,8.4,0,0,1,12.1.07a8.277,8.277,0,0,1,7.114,8.254v5.36l2.2,2.164a1.928,1.928,0,0,1,.43,2.14A1.992,1.992,0,0,1,20,19.2H15.89v.408A4.666,4.666,0,0,1,11,24ZM8.556,19.2v.408A2.284,2.284,0,0,0,11,21.6a2.285,2.285,0,0,0,2.445-1.992V19.2ZM10.992,2.4A5.719,5.719,0,0,0,7.213,3.8a5.634,5.634,0,0,0-1.98,4.267v5.613a2.362,2.362,0,0,1-.716,1.7L3.074,16.8H18.928L17.485,15.38a2.36,2.36,0,0,1-.715-1.7V8.324A5.857,5.857,0,0,0,11.78,2.45,6.186,6.186,0,0,0,10.992,2.4Z",
    transform: "translate(0.001 -0.001)",
    fill: "#a2adbf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-export",
    transform: "translate(14 12.886)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_106",
    "data-name": "Vrstva 106",
    transform: "translate(0.846 1.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_86",
    "data-name": "Pfad 86",
    d: "M10.107,21.352H3.5a2.508,2.508,0,0,1-2.131-1.12A2.416,2.416,0,0,1,.93,18.844V13.829a.786.786,0,0,1,.493-.786.786.786,0,0,1,.9.134.836.836,0,0,1,.276.644v4.965a.836.836,0,0,0,.326.685.777.777,0,0,0,.485.167H16.736a.836.836,0,0,0,.894-.9V13.829a.833.833,0,0,1,1.663-.092.518.518,0,0,1,0,.109v4.923a2.508,2.508,0,0,1-2.508,2.508Z",
    transform: "translate(-0.928 -3.784)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_87",
    "data-name": "Pfad 87",
    d: "M10.452,4.51v10.7a.961.961,0,0,0,.109.5.836.836,0,0,0,1.563-.426V4.51l.125.1L14.3,6.282A.854.854,0,0,0,15.35,4.937L11.931,2.2a.978.978,0,0,0-1.237,0L7.242,4.945A.825.825,0,0,0,8.295,6.215L9.774,5.028Z",
    transform: "translate(-1.915 -1.983)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_15581",
    "data-name": "Gruppe 15581",
    transform: "translate(-38 -164.886)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_202",
    "data-name": "Rechteck 202",
    width: 48,
    height: 48,
    transform: "translate(24 152)",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload2);
export default __webpack_public_path__ + "static/media/icon-upload_2.6fe52ddb31cbf59948b3bef8d5ebd4f1.svg";
export { ForwardRef as ReactComponent };